import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { AddIcon, DownloadIcon } from "../../Assets/assets";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import Button from "../../Components/Button/Button";
import { GraphCard, LegendCard } from "../../Components/Cards/Cards";
import CreateLocation from "../../Components/CreateLocation/CreateLocation";
import FilterCarousal from "../../Components/FilterCarousal/FilterCarousal";
import DateRange from "../../Components/Filters/DateRange";
import MultipleSelect from "../../Components/Filters/MultipleSelect";
import { DoughnutChart } from "../../Components/Graphs/DoughnutChart";
import LocationPreview from "../../Components/Previews/LocationPreview";
import SearchBox from "../../Components/SearchBox/SearchBox";
import SummaryHeader from "../../Components/SummaryHeader/SummaryHeader";
import Table from "../../Components/Table/Table";
import { useResizeObserver } from "../../CustomHooks/useResizeObserver";
import { getTodayComplaintCount } from "../../Redux/complaints/action";
import {
  createNewLocation,
  fetchLocationsAssets,
  fetchSelectedLocationData,
  getLocationSummary,
  setSelectedLocationData,
  uploadLocationImage
} from "../../Redux/locations/action";
import { setErrorStatus } from "../../Redux/status/action";
import {
  setSelectedTableData,
  setTableFilter,
  setTableSearchKey,
  setTableSort
} from "../../Redux/table/action";
import { isValidArray } from "../../Services/validators";
import { getClosedDurationChartData, getRaisedChartData } from "../../Utils/Constants/Complaints";
import {
  FilterSeparator,
  isFilterApplied,
  summaryRefreshTime
} from "../../Utils/Constants/Constants";
import {
  defaultLocationFilter,
  getLocationOperationalStatusChartData,
  getZoneWiseLocationsChartData,
  locationFilterData,
  locationTableField,
  locationTableHeadings
} from "../../Utils/Constants/Locations";
import LineChart from "../../Components/Graphs/LineChart";

function Overview(props) {
  const [selectedFilters, setSelectedFilters] = useState(defaultLocationFilter);
  const [collapse, setCollapse] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    props.table.locations.pageNumber
  );
  const [searchKey, setSearchKey] = useState("");
  const tableContainerRef = useRef(null);
  const filterContainerRef = useRef(null);
  const { height } = useResizeObserver(filterContainerRef);
  const [isResetSingleKey, setIsResetSingleKey] = useState(false);
  // eslint-disable-next-line
  const [time, setTime] = useState(new Date()); // for render

  const [summaryLastRefreshedAt, setSummaryLastRefreshedAt] = useState(null);
  const summaryRefreshTimer = useRef(null);

  const rerenderRef = useRef(false);

  useEffect(() => {
    rerenderRef.current = setInterval(() => {
      setTime(new Date());
    }, 30000);

    return () => {
      if (rerenderRef.current) {
        clearInterval(rerenderRef.current);
        rerenderRef.current = false;
      }
    };
  }, []);

  useEffect(() => {
    if (props.table.locations.pageNumber) {
      setCurrentPage(props.table.locations.pageNumber);
    }
    // eslint-disable-next-line
  }, [props.table.locations.pageNumber]);

  useEffect(() => {
    if (!isResetSingleKey) {
      setSelectedFilters(props.table.locations.filter);
    }
  }, [props.table.locations.filter, isResetSingleKey]);

  useEffect(() => {
    if (props.table.locations.searchKey) {
      setSearchKey(props.table.locations.searchKey);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getLocationSummary();
    // eslint-disable-next-line
  }, [props.locations.data, props.workforce.data, props.workforce.operations]);

  useEffect(() => {
    if (collapse) {
      return;
    }
    props.getTodayComplaintCount();
    setSummaryLastRefreshedAt(+new Date());
    // eslint-disable-next-line
  }, [props.table.locations.filter, collapse]);

  useEffect(() => {
    if (summaryLastRefreshedAt) {
      if (summaryRefreshTimer.current) {
        clearInterval(summaryRefreshTimer.current);
        summaryRefreshTimer.current = null;
      }
      if (collapse) {
        return;
      }
    } else {
      return;
    }

    summaryRefreshTimer.current = setInterval(() => {
      props.getTodayComplaintCount();
      setSummaryLastRefreshedAt(+new Date());
    }, summaryRefreshTime);
    // eslint-disable-next-line
  }, [summaryLastRefreshedAt, collapse]);

  // const locationDataTotals = useMemo(() => {
  //   if (isValidObject(props.locations.data)) {
  //     return Object.values(props.locations.data)?.reduce(
  //       (acc, item) => {
  //         acc.optimal += item.status === "Optimal" || 0;
  //         acc.moderate += item.status === "Moderate" || 0;
  //         acc.critical += item.status === "Critical" || 0;
  //         return acc;
  //       },
  //       {
  //         optimal: 0,
  //         moderate: 0,
  //         critical: 0
  //       }
  //     );
  //   }
  // }, [props.locations.data]);

  // const InfoCardData = [
  //   {
  //     title: "TOTAL LOCATIONS",
  //     value: isValidObject(props.locations.data)
  //       ? Object.values(props.locations.data).length
  //       : 0,
  //     // difference: "24",
  //     // progression: "positive",
  //     unit: null,
  //     icon: <LocationCardIcon color="var(--tertiaryColor6)" />
  //   },
  //   {
  //     title: "MANPOWER",
  //     value:
  //       `${props.locations.graphSummaryData?.manPower?.captured} %` || "N/A",
  //     // difference: "5",
  //     // progression: "positive",
  //     unit: "hrs",
  //     icon: <ReviewCardIcon color="var(--tertiaryColor6)" />
  //   },
  //   {
  //     title: "LAST EMPLOYEE CAPTURE",
  //     value:
  //       `${props.locations.graphSummaryData?.manPower?.lastEmployeeCaptured} %` ||
  //       "N/A",
  //     // difference: "3",
  //     // progression: "negative",
  //     unit: null,
  //     icon: <ClockCardIcon color="var(--tertiaryColor6)" />
  //   }
  // ];

  // const sampleBarChartData = {
  //   labels: ["Jan", "Feb", "March", "April", "May", "June", "July"],
  //   datasets: [
  //     {
  //       label: "Dataset 1",
  //       data: [65, 59, 80, 81, 56, 55, 40],
  //       fill: true,
  //       backgroundColor: "rgba(237, 237, 237, 0.1)",
  //       borderColor: "white",
  //       tension: 0.1
  //     }
  //   ]
  // };

  const handleApplyClick = () => {
    props.setTableFilter("LOCATIONS", selectedFilters);
  };

  const handleResetClick = (key) => {
    setIsResetSingleKey(true);
    setSelectedFilters({
      ...selectedFilters,
      [key]: defaultLocationFilter[key]
    });
    props.setTableFilter("LOCATIONS", {
      ...props.table.locations.filter,
      [key]: defaultLocationFilter[key]
    });
  };

  const handleClearClick = () => {
    props.setTableFilter("LOCATIONS", defaultLocationFilter);
    setSelectedFilters(defaultLocationFilter);
    props.setTableSearchKey("LOCATIONS", "");
    setSearchKey("");
  };

  const handleDisableFilter = () => {
    return window.location.pathname.split("/")[3] ? true : false;
  };

  return (
    <>
      <Routes>
        <Route
          path="/:locationId"
          element={
            <LocationPreview
              navigate={props.navigate}
              locationData={props.locations.selectedLocation}
              selectedSummaryData={
                props.workforce.captureSummary?.[
                  props.table.locations.selectedLocation
                ]
              }
              locationsLoading={props.locationsLoading}
              filter={props.table.locations.filter}
              roles={props.workforce.roles}
              uploadLocationImage={props.uploadLocationImage}
              fetchLocationsAssets={props.fetchLocationsAssets}
              fetchSelectedLocationData={props.fetchSelectedLocationData}
              rolesData={props.workforce.roles}
              setSelectedLocationData={props.setSelectedLocationData}
            />
          }
        />
        <Route
          path="/createLocation"
          element={
            <CreateLocation
              navigate={props.navigate}
              data={
                props.complaints?.data?.[
                  props.table.complaints.selectedComplaint
                ]
              }
              createNewLocationLoading={props.locations.loading}
              createNewLocation={(data) => {
                props.createNewLocation(data);
              }}
              locations={props.locations}
            />
          }
        />
      </Routes>
      <div
        className="inherit-parent-height inherit-parent-width position-relative overflow-hidden"
        ref={tableContainerRef}
      >
        <div
          className={`inherit-parent-width ${
            collapse ? "" : "margin-bottom-larger"
          }`}
        >
          <div className="display-flex flex-justify-content-space-between flex-align-items-center">
            <BreadCrumbs />
            <div className="display-flex" style={{ gap: "12px" }}>
              <div>
                <Button
                  text="New location"
                  data-cy="CREATE-NEW-LOCATION-BUTTON"
                  boxShadow={false}
                  icon={
                    <AddIcon
                      color={
                        props.auth.theme.primaryColor === "#0E0E0E"
                          ? "#0E0E0E"
                          : "#FFFFFF"
                      }
                    />
                  }
                  onClick={() => {
                    props.navigate("/locations/overview/createLocation");
                  }}
                  className="width-fit-content padding-left-large padding-right-large"
                />
              </div>
              <div>
                <Button
                  variant="transparent"
                  text="Download summary"
                  data-cy="DOWNLOAD-LOCATIONS-SUMMARY-BUTTON"
                  boxShadow={false}
                  icon={
                    props.locationsLoading?.export ? (
                      <div
                        className="qr-loader"
                        style={{ height: "16px", width: "16px" }}
                      />
                    ) : (
                      <DownloadIcon color="var(--tertiaryColor6)" />
                    )
                  }
                  onClick={() => {
                    if (!props.locationsLoading?.export) {
                      props.getLocationsSummary();
                    }
                  }}
                  className="width-fit-content padding-left-large padding-right-large"
                />
              </div>
            </div>
          </div>

          <div
            ref={filterContainerRef}
            className="padding-top-larger display-flex flex-justify-content-space-between"
          >
            <div
              style={{ width: "90%", flexWrap: "wrap", gap: "8px" }}
              className="display-flex flex-align-items-center"
            >
              <div style={{ width: "200px" }}>
                <SearchBox
                  title="SEARCH LOCATIONS"
                  placeHolder="SEARCH LOCATIONS"
                  value={searchKey}
                  onChange={(event) => {
                    if (event.target.value.length > 0) {
                      setSearchKey(event.target.value);
                    } else {
                      setSearchKey("");
                      props.setTableSearchKey("LOCATIONS", "");
                    }
                  }}
                  showEnterIcon={
                    searchKey.length > 0 &&
                    props.table.locations.searchKey !== searchKey
                      ? true
                      : false
                  }
                  enterOnClick={() => {
                    if (searchKey.length > 0) {
                      props.setTableSearchKey("LOCATIONS", searchKey);
                    }
                  }}
                  showCloseIcon={
                    searchKey.length > 0 &&
                    props.table.locations.searchKey === searchKey
                      ? true
                      : false
                  }
                  closeOnClick={() => {
                    if (props.table.locations.searchKey.length > 0) {
                      setSearchKey("");
                      props.setTableSearchKey("LOCATIONS", "");
                    }
                  }}
                />
              </div>
              <div
                style={{
                  width: `calc(100% - ${220 +
                    (isFilterApplied(selectedFilters, "LOCATIONS").validation
                      ? 200
                      : 180)}px)`
                }}
                className="position-relative"
              >
                <FilterCarousal>
                  <div className="display-flex flex-align-items-center">
                    <DateRange
                      disabled={handleDisableFilter()}
                      loading={props.locations.loading}
                      data-cy="DATE RANGE"
                      multiple={true}
                      data={
                        locationFilterData({
                          wards: props.locations.wards,
                          zones: props.locations.zones
                        })[1]
                      }
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      isFilterApplied={
                        props.table.locations.filter?.dateRange?.from &&
                        props.table.locations.filter?.dateRange?.to &&
                        props.table.locations.filter?.dateRange?.from !==
                          new Date().toISOString().split("T")[0]
                      }
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.locations.filter}
                      selected={selectedFilters["dateRange"]}
                    />

                    <FilterSeparator />

                    <MultipleSelect
                      disabled={handleDisableFilter()}
                      loading={props.locations.loading}
                      data-cy="CATEGORY-MULTI"
                      data={
                        locationFilterData({
                          wards: props.locations.wards,
                          zones: props.locations.zones
                        })[0]
                      }
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.locations.filter}
                      selected={selectedFilters["category"]}
                    />

                    <FilterSeparator />

                    <MultipleSelect
                      disabled={handleDisableFilter()}
                      loading={props.locations.loading}
                      data-cy="STATUS-MULTI"
                      data={
                        locationFilterData({
                          wards: props.locations.wards,
                          zones: props.locations.zones
                        })[2]
                      }
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.locations.filter}
                      selected={selectedFilters["status"]}
                    />

                    <FilterSeparator />

                    <MultipleSelect
                      disabled={handleDisableFilter()}
                      loading={props.locations.loading}
                      data-cy="WARD-MULTI"
                      data={
                        locationFilterData({
                          wards: props.locations.wards,
                          zones: props.locations.zones
                        })[3]
                      }
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.locations.filter}
                      selected={selectedFilters["ward"]}
                    />

                    <FilterSeparator />

                    <MultipleSelect
                      disabled={handleDisableFilter()}
                      loading={props.locations.loading}
                      data-cy="ZONE-MULTI"
                      data={
                        locationFilterData({
                          wards: props.locations.wards,
                          zones: props.locations.zones
                        })[4]
                      }
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.locations.filter}
                      selected={selectedFilters["zone"]}
                    />
                  </div>
                </FilterCarousal>
              </div>
            </div>

            {isFilterApplied(selectedFilters, "LOCATIONS").validation && (
              <div
                style={{
                  width: "10%"
                }}
                className={`display-flex flex-justify-content-space-between`}
              >
                <div
                  style={{
                    width: "60%"
                  }}
                >
                  <Button
                    data-cy="FILTER-APPLY-BUTTON"
                    text="Apply"
                    boxShadow={false}
                    variant="filter"
                    loading={props.loading}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleApplyClick();
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "40%"
                  }}
                >
                  <Button
                    data-cy="FILTER-RESET-BUTTON"
                    variant="transparent"
                    text="Clear"
                    boxShadow={false}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      props.setTableFilter("LOCATIONS", defaultLocationFilter);
                      setSelectedFilters(defaultLocationFilter);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            height: `calc(100% - ${height + 32 + (collapse ? 0 : 24)}px`
          }}
          className={`${
            collapse ? "overflow-hidden" : "overflow-scroll"
          } inherit-parent-width`}
        >
          {!collapse && (
            <div
              className="inherit-parent-width overflow-hidden"
              style={{
                height: "597px"
              }}
            >
              <div
                style={{
                  overflowX: "scroll"
                }}
                className="inherit-parent-height hide-scrollbar"
              >
                <SummaryHeader
                  summaryLastRefreshedAt={summaryLastRefreshedAt}
                  refreshOnClick={() => {
                    props.getTodayComplaintCount();
                    setSummaryLastRefreshedAt(+new Date());
                  }}
                  isLoading={props.complaints.summaryLoading}
                />
                {/* <div className="display-flex flex-justify-content-space-between">
                  {InfoCardData.map((data, i) => (
                    <React.Fragment key={i}>
                      <InfoCard data={data} />
                      {i !== InfoCardData.length - 1 && (
                        <div style={{ margin: "12px" }} />
                      )}
                    </React.Fragment>
                  ))}
                </div> */}
                <div className="display-flex flex-justify-content-space-between">
                  <GraphCard
                    title="ZONE WISE LOCATIONS"
                    theme={
                      props.auth.theme.primaryColor === "#0E0E0E"
                        ? "dark"
                        : "light"
                    }
                    isLoading={props.locations.loading || props.complaints.summaryLoading}
                    graph={
                      <DoughnutChart
                        data={getZoneWiseLocationsChartData(
                          props.locations.graphSummaryData?.zoneCounts
                        )}
                      />
                    }
                    legend={
                      <div className="display-flex flex-justify-content-center padding-top-large flex-direction-column">
                        {getZoneWiseLocationsChartData(
                          props.locations.graphSummaryData?.zoneCounts
                        )?.datasets[0].backgroundColor.map((data, i) => (
                          <div key={i}>
                            <LegendCard
                              data={getZoneWiseLocationsChartData(
                                props.locations.graphSummaryData?.zoneCounts
                              )}
                              color={data}
                              index={i}
                            />
                          </div>
                        ))}
                      </div>
                    }
                  />
                  
                  <div style={{ padding: "12px" }} />

                  <GraphCard
                    title="TODAY'S COMPLAINTS"
                    theme={
                      props.auth.theme.primaryColor === "#0E0E0E"
                        ? "dark"
                        : "light"
                    }
                    isLoading={
                      props.locations.loading || props.complaints.summaryLoading
                    }
                    graph={
                      <DoughnutChart
                        data={getRaisedChartData(
                          props.complaints?.todayComplaintsCount
                        )}
                      />
                    }
                    legend={
                      <div className="display-flex flex-justify-content-center padding-top-large flex-direction-column">
                        {getRaisedChartData(
                          props.complaints?.todayComplaintsCount
                        )?.datasets[0].backgroundColor.map((data, i) => (
                          <div key={i}>
                            <LegendCard
                              data={getRaisedChartData(
                                props.complaints?.todayComplaintsCount
                              )}
                              color={data}
                              index={i}
                            />
                          </div>
                        ))}
                      </div>
                    }
                  />
                  <div style={{ padding: "12px" }} />

                  {/* <GraphCard
                    title="TODAY'S ATTENDANCE"
                    theme={
                      props.auth.theme.primaryColor === "#0E0E0E"
                        ? "dark"
                        : "light"
                    }
                    isLoading={false}
                    graph={
                      <DoughnutChart
                        disableCustomToolTip={true}
                        data={getAttendanceChartData(
                          props.locations.graphSummaryData?.employeeAttendance
                        )}
                      />
                    }
                    legend={
                      <div className="display-flex flex-justify-content-center padding-top-large flex-direction-column">
                        {getAttendanceChartData(
                          props.locations.graphSummaryData?.attendance
                        )?.datasets[0].backgroundColor.map((data, i) => (
                          <div key={i}>
                            <LegendCard
                              data={getAttendanceChartData(
                                props.locations.graphSummaryData?.attendance
                              )}
                              color={data}
                              index={i}
                            />
                          </div>
                        ))}
                      </div>
                    }
                  /> */}

                  <GraphCard
                    title="ACTIVE WORKFORCE"
                    theme={
                      props.auth.theme.primaryColor === "#0E0E0E"
                        ? "dark"
                        : "light"
                    }
                    isLoading={
                      props.locations.loading || props.complaints.summaryLoading
                    }
                    widthFull={true}
                    customData={
                      <div className="text-align-center padding-top-large inherit-parent-width">
                        <div>
                          <div
                            style={{
                              transform: "translateY(80%)"
                            }}
                            className=""
                          >
                            <ManPowerIcon color="var(--secondaryColor)" />
                          </div>
                          <div
                            style={{
                              fontSize: "72px",
                              fontWeight: "bold",
                              height: "fit-content"
                            }}
                            className="font-color-tertiaryColor"
                          >
                            {props.locations.graphSummaryData
                              ?.employeeAttendance?.present || 0}
                          </div>
                          <div
                            style={{
                              transform: "translateY(-50%)"
                            }}
                            className="font-color-tertiaryColor6"
                          >
                            EMPLOYEES
                          </div>
                        </div>
                        <div className="font-color-tertiaryColor6 padding-top-larger">
                          Keeping the PCTs accessible to the public
                        </div>
                      </div>
                    }
                    legend={false}
                  />

                  {/* <div style={{ padding: "12px" }} />

                  <GraphCard
                    title="PENALTY HISTORY"
                    // comingSoon={true}
                    isLoading={
                      props.locations.data === null || props.locations?.loading
                    }
                    theme={
                      props.auth.theme.primaryColor === "#0E0E0E"
                        ? "dark"
                        : "light"
                    }
                    type="line"
                    graph={<LineChart data={sampleBarChartData} />}
                    legend={
                      <div
                        style={{
                          paddingTop: "31px"
                        }}
                      />
                    }
                  /> */}
                </div>

                 <div className="display-flex flex-justify-content-space-between padding-top-larger hide-scrollbar">
                <GraphCard
                    title="ACTIVE LOCATIONS"
                    graph={
                      <DoughnutChart
                        data={getLocationOperationalStatusChartData(
                          props.locations.data
                        )}
                      />
                    }
                    legend={
                      <div className="display-flex flex-justify-content-center padding-top-large flex-direction-column">
                        {getLocationOperationalStatusChartData(
                          props.locations.data
                        )?.datasets[0].backgroundColor.map((color, i) => (
                          <div key={i}>
                            <LegendCard
                              data={getLocationOperationalStatusChartData(
                                props.locations.data
                              )}
                              color={color}
                              index={i}
                            />
                          </div>
                        ))}
                      </div>
                    }
                  />
                    <div style={{ padding: "12px" }} />


                  <GraphCard
                      title="COMING SOON"
                      type="line"
                      comingSoon={true}
                      isLoading={
                        !props.complaints?.summaryData.find(
                          (data) => data.title === "LONGEST DURATION COMPLAINTS"
                        )?.complaints || props.complaints.summaryLoading
                      }
                      theme={
                        props.auth.theme.primaryColor === "#0E0E0E"
                          ? "dark"
                          : "light"
                      }
                      graph={
                        <LineChart
                          data={getClosedDurationChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "COMING SOON 1"
                            )?.count
                          )}
                        />
                      }
                      legend={
                        <div
                          style={{
                            paddingTop: "31px"
                          }}
                        />
                      }
                    />
                    <div style={{ padding: "12px" }} />

                    <GraphCard
                      title="COMING SOON"
                      type="line"
                      isLoading={
                        !props.complaints?.summaryData.find(
                          (data) => data.title === "LONGEST DURATION COMPLAINTS"
                        )?.complaints || props.complaints.summaryLoading
                      }
                      comingSoon={true}
                      theme={
                        props.auth.theme.primaryColor === "#0E0E0E"
                          ? "dark"
                          : "light"
                      }
                      graph={
                        <LineChart
                          data={getClosedDurationChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "COMING SOON 1"
                            )?.count
                          )}
                        />
                      }
                      legend={
                        <div
                          style={{
                            paddingTop: "31px"
                          }}
                        />
                      }
                    />
                    </div>
              </div>
            </div>
          )}

          {height && (
            <div
              style={{
                height: collapse ? `calc(100% - 0px)` : "fit-content"
              }}
              className="padding-top-larger"
            >
              <Table
                title="ALL LOCATIONS"
                setCollapse={(data) => {
                  setCollapse(data);
                  if (tableContainerRef.current) {
                    tableContainerRef.current.scrollTop = 0;
                  }
                }}
                disableSorting={
                  props.table.locations.searchKey.length > 0 ? true : false
                }
                allowCollapse={true}
                collapse={collapse}
                headers={locationTableHeadings}
                onClick={(data) => {
                  props.setSelectedTableData("LOCATIONS", data.documentId);
                  props.navigate(`locations/overview/${data.documentId}`);
                }}
                data={
                  isValidArray(props.locations.results)
                    ? props.locations.results.slice(0, !collapse ? 10 : 50)
                    : []
                }
                getField={locationTableField}
                totalPage={Math.ceil(props.locations.total / 50)}
                currentPage={currentPage}
                previousPageOnClick={() => {
                  props.getLocationPreviousPage();
                }}
                nextPageOnClick={() => {
                  props.getLocationNextPage();
                }}
                resetAllClick={() => {
                  handleClearClick();
                }}
                sort={props.table.locations.sort}
                handleSort={(title) => {
                  if (props.table.locations.searchKey.length > 0) {
                    return;
                  }
                  props.setTableSort("LOCATIONS", {
                    title: title,
                    ascending:
                      props.table?.locations?.sort?.title === title
                        ? !props.table?.locations?.sort?.ascending
                        : true
                  });
                }}
                backgroundColor="background-color-primary"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = function(state) {
  return {
    auth: state.auth,
    locations: state.locations,
    table: state.table,
    workforce: state.workforce,
    complaints: state.complaints,
    procedures: state.procedures
  };
};

const mapDispatchToProps = function() {
  return {
    setSelectedTableData: (tableName, data) =>
      setSelectedTableData(tableName, data),
    setTableFilter: (tableName, data) => setTableFilter(tableName, data),
    createNewLocation: (data) => createNewLocation(data),
    setTableSort: (tableName, data) => setTableSort(tableName, data),
    setTableSearchKey: (tableName, value) =>
      setTableSearchKey(tableName, value),
    uploadLocationImage: (data, locationId) =>
      uploadLocationImage(data, locationId),
    setErrorStatus: (error) => setErrorStatus(error),
    fetchSelectedLocationData: (dateRange) =>
      fetchSelectedLocationData(dateRange),
    fetchLocationsAssets: () => fetchLocationsAssets(),
    setSelectedLocationData: (data) => setSelectedLocationData(data),
    getTodayComplaintCount: () => getTodayComplaintCount()
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Overview);

const ManPowerIcon = (props) => {
  return (
    <svg
      width="32"
      height="19"
      viewBox="0 0 32 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.1508 13.15C28.4508 9.05 25.9508 5.65 22.4508 3.75L21.8508 8.35C21.7508 9.15 21.0508 9.65 20.3508 9.65C20.2508 9.65 20.1508 9.65 20.0508 9.65C19.2508 9.55 18.7508 8.75 18.8508 7.95L19.6508 1.65C19.7508 1.15 19.3508 0.75 18.8508 0.75H13.1508C12.6508 0.75 12.3508 1.25 12.3508 1.65L13.1508 7.95C13.2508 8.75 12.7508 9.55 11.9508 9.65C11.8508 9.65 11.7508 9.65 11.6508 9.65C10.8508 9.65 10.2508 9.05 10.1508 8.35L9.55078 3.75C6.05078 5.65 3.55078 9.15 2.85078 13.15C1.55078 13.35 0.550781 14.45 0.550781 15.85V17.05C0.550781 17.65 1.05078 18.15 1.65078 18.15H30.3508C30.9508 18.15 31.4508 17.65 31.4508 17.05V15.85C31.4508 14.45 30.4508 13.35 29.1508 13.15Z"
        fill={props.color || "#20C74F"}
      />
    </svg>
  );
};
